module.exports = __webpack_public_path__ + "static/media/3f642e12-dc2c-4c9a-9337-341f42485c8e.1f19d258.JPG";